import { Action } from '../actions'
import { ExportDialog } from '../constants'

export function isExportDialogOpen(currentIsExportDialogOpen: boolean = false, action: Action): boolean {
  switch (action.type) {
    case ExportDialog.SET_EXPORT_DIALOG_VISIBILITY:
      return action.visibility
    default:
      return currentIsExportDialogOpen
  }
}
